export default __webpack_public_path__ + "files/gov-8eb7a7f6a45e0083acadc340ea90141c.png";